import { render, staticRenderFns } from "./4mPlan.vue?vue&type=template&id=6676aae7"
import script from "./4mPlan.vue?vue&type=script&lang=js"
export * from "./4mPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6676aae7')) {
      api.createRecord('6676aae7', component.options)
    } else {
      api.reload('6676aae7', component.options)
    }
    module.hot.accept("./4mPlan.vue?vue&type=template&id=6676aae7", function () {
      api.rerender('6676aae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/plan/4mPlan.vue"
export default component.exports